"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Info = function Info() {
  return _react2.default.createElement(
    "g",
    { id: "info" },
    _react2.default.createElement("path", {
      d: "M275.96,175 L225.96,175 L225.96,125 L275.96,125 L275.96,175 Z M275.96,375 L225.96,375 L225.96,225 L275.96,225 L275.96,375 Z M251.21,500 C389.21,500 500.96,388 500.96,250 C500.96,112 389.25,0 251.25,0 C112.96,0 0.96,112 0.96,250 C0.96,388 112.96,500 251.25,500 L251.21,500 Z M250.96,50 C361.41695,50 450.96,139.54305 450.96,250 C450.96,360.45695 361.41695,450 250.96,450 C140.50305,450 50.96,360.45695 50.96,250 C50.9440784,196.951823 72.0103335,146.071789 109.521061,108.561061 C147.031789,71.0503335 197.911823,49.9840784 250.96,50 L250.96,50 Z",
      id: "Shape"
    })
  );
};

exports.default = Info;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Info.js
// module id = 2962
// module chunks = 4